import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../imageWithBasePath";
import { useDispatch, useSelector } from "react-redux";

const Slider: React.FC<{ hlanguage: any, allImagesLink: any }> = ({ hlanguage, allImagesLink }) => {
  const base_Url = process.env.REACT_APP_BASE_URL;
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [loadedCount, setLoadedCount] = useState(0);

  const totalImages = allImagesLink?.slider?.length || 0;

  useEffect(() => {
    if (totalImages === 0) {
      setImagesLoaded(true);
      return;
    }

    setLoadedCount(0);
    setImagesLoaded(false);

    // Preload all images
    allImagesLink.slider.forEach((slide: any) => {
      const img = new Image();
      img.src = `${base_Url}${slide.fileUrl}`;
      img.onload = () => {
        setLoadedCount((prev) => {
          const newCount = prev + 1;
          if (newCount === totalImages) {
            setImagesLoaded(true);
          }
          return newCount;
        });
      };
      img.onerror = () => {
        setLoadedCount((prev) => {
          const newCount = prev + 1;
          if (newCount === totalImages) {
            setImagesLoaded(true);
          }
          return newCount;
        });
      };
    });
  }, [allImagesLink, base_Url, totalImages]);


  return (
    <div style={{ position: "relative" }}>
      <style>{`
        @media (max-width: 576px) {
          .carousel-item {
            height: 50vh !important;
          }
        }
        
        @media (min-width: 577px) and (max-width: 768px) {
          .carousel-item {
            height: 55vh !important;
          }
        }
        
        @media (min-width: 769px) and (max-width: 992px) {
          .carousel-item {
            height: 60vh !important;
          }
        }

        .slider-loader-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 75vh;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 100;
          backdrop-filter: blur(5px);
          pointer-events: none;
        }

        .slider-loader-spinner {
          border: 4px solid rgba(255, 255, 255, 0.3);
          border-top: 4px solid white;
          border-radius: 50%;
          width: 50px;
          height: 50px;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @media (max-width: 576px) {
          .slider-loader-overlay {
            height: 50vh;
          }
        }
        
        @media (min-width: 577px) and (max-width: 768px) {
          .slider-loader-overlay {
            height: 55vh;
          }
        }
        
        @media (min-width: 769px) and (max-width: 992px) {
          .slider-loader-overlay {
            height: 60vh;
          }
        }
      `}</style>

      {/* Loader Overlay */}
      {!imagesLoaded && (
        <div className="slider-loader-overlay">
          <div className="slider-loader-spinner"></div>
        </div>
      )}

      <div
        id="carouselExampleCaptions"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="3000"
        style={{ opacity: imagesLoaded ? 1 : 0.3, transition: "opacity 0.3s ease" }}
      >
        {/* Carousel indicators */}
        <div className="carousel-indicators">
          {allImagesLink?.slider?.map((_: any, index: number) => (
            <button
              key={index}
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-current={index === 0 ? "true" : "false"}
              aria-label={`Slide ${index + 1}`}
            ></button>
          ))}
        </div>

        {/* Carousel slides */}
        <div className="carousel-inner">
          {allImagesLink?.slider?.map((slide: any, index: number) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
              style={{
                backgroundImage: `url(${base_Url}${slide.fileUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: "75vh",
                color: "white",
              }}
            >
            </div>
          ))}
        </div>

        {/* Controls */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default Slider;